import { useState, useEffect } from "react";
import throttle from "lodash.throttle";
import s from "../Panel/Panel.module.css";

const getSettings = (edge) => {
    const { isHorizontal, location, wallSize, box, horizontalIndex } = edge;
    const posW = (box.right - location[horizontalIndex]) / wallSize.width;
    const posH = (box.top - location[2]) / wallSize.height;

    return { posW, posH, isHorizontal, lehgth: 1 };
};

const EdgePanel = ({ submit, edge, removeEdge }) => {
    const [settings, setSettings] = useState(getSettings(edge));
    const [needUpdate, setNeedUpdate] = useState(false);

    useEffect(() => {
        if (needUpdate) {
            const location = [...edge.location];
            const { posH, posW } = settings;
            const { box, horizontalIndex, wallSize } = edge;
            location[horizontalIndex] = box.right - posW * wallSize.width;
            location[2] = box.top - posH * wallSize.height;
            edge.location = location;
            submit();

            setNeedUpdate(false);
        }
    }, [settings, needUpdate, submit, edge]);

    const setProp = (e) => {
        const { name, value } = e.target;
        setSettings((prev) => ({ ...prev, [name]: Number(value) }));
        setNeedUpdate(true);
    };

    // const setProp = (name, value) => {
    //     setSettings((prev) => ({ ...prev, [name]: value }));
    //     setNeedUpdate(true);
    // };

    const setHorizontal = (value) => {
        if (value !== settings.isHorizontal) {
            const { x, y, z } = edge.boxCenter;
            if (value) {
                edge.size = [1, edge.wallSize.width / edge.wallSize.height, 1];
                edge.turning = [edge.turning[0], edge.turning[1], Math.PI / 2];
            } else {
                edge.size = [1, 1, 1];
                edge.turning = [edge.turning[0], edge.turning[1], 0];
            }
            edge.isHorizontal = value;
            edge.location = [x, y, z];
            setSettings((prev) => ({
                ...prev,
                isHorizontal: value,
                posW: 0.5,
                posH: 0.5,
            }));
            setNeedUpdate(true);
        }
    };

    return (
        <>
            <div className={s.prop}>
                <p>Tile edge position in width</p>
                <input
                    type="range"
                    name="posW"
                    min={0}
                    max={1}
                    step={0.01}
                    value={settings.posW}
                    onChange={throttle(setProp, 300)}
                />
            </div>

            <div className={s.prop}>
                <p>Tile edge position in height</p>
                <input
                    type="range"
                    name="posH"
                    min={0}
                    max={1}
                    step={0.01}
                    value={settings.posH}
                    onChange={throttle(setProp, 300)}
                />
            </div>

            <div className={s.prop}>
                <p>Tile edge length</p>
                <input
                    type="range"
                    name="lenght"
                    min={0}
                    max={1}
                    step={0.01}
                    value={settings.lenght}
                    onChange={throttle(setProp, 300)}
                />
            </div>

            <div className={s.prop}>
                <p>Orientation: </p>
                <div className={s.flexBox}>
                    <div className={s.btnBox}>
                        <button
                            className={
                                settings.isHorizontal ? s.btn : s.passiveBtn
                            }
                            type="button"
                            onClick={() => setHorizontal(true)}
                        >
                            Horizontal
                        </button>
                        <button
                            className={
                                settings.isHorizontal ? s.passiveBtn : s.btn
                            }
                            type="button"
                            onClick={() => setHorizontal(false)}
                        >
                            Vertical
                        </button>
                    </div>
                </div>
            </div>

            <div className={s.prop}>
                <button className={s.btn} onClick={removeEdge}>
                    Remove edge
                </button>
            </div>
        </>
    );
};

export default EdgePanel;
